var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5374 7.00014C13.5374 10.8661 10.5069 14 6.76885 14C3.03072 14 0 10.8653 0 7.00014C0 3.13488 3.03051 0 6.76885 0C10.5071 0 13.5374 3.13417 13.5374 7.00014ZM20.9628 7.00014C20.9628 10.639 19.4476 13.5902 17.5784 13.5902C15.7092 13.5902 14.194 10.639 14.194 7.00014C14.194 3.36118 15.709 0.410027 17.5782 0.410027C19.4474 0.410027 20.9626 3.36024 20.9626 7.00014H20.9628ZM24 7.00014C24 10.2598 23.4671 12.9038 22.8097 12.9038C22.1522 12.9038 21.6196 10.2604 21.6196 7.00014C21.6196 3.73981 22.1524 1.09647 22.8097 1.09647C23.4669 1.09647 24 3.73959 24 7.00014Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.0a31f18febf7e4323883c2466df937ad.svg";
export { ForwardRef as ReactComponent };